import { LoadablePaint, MustPreloadLoadableNames } from '@confluence/loadable';

export const ViewPageLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ViewPage" */ '../src/ViewPage.tsx')).ViewPage,
	_mustPreloadWhenRenderingSPA: [MustPreloadLoadableNames.ViewPageRouteComponentLoader],
});
